import { Stroke, Style, Text } from "ol/style.js";
import { Color } from "./color";
import Fill from "ol/style/Fill";
import TextPlacement from "ol/style/Text";
import CircleStyle from 'ol/style/Circle';
export default class JobStyle {
    constructor(colorGradient = [
        new Color(112, 148, 194),
        new Color(103, 142, 191),
        new Color(93, 135, 188),
        new Color(84, 129, 186),
        new Color(47, 103, 174),
        new Color(75, 122, 183),
        new Color(65, 116, 180),
        new Color(56, 109, 177),
        new Color(37, 96, 171),
        new Color(28, 90, 168),
        new Color(19, 83, 166),
        new Color(9, 77, 163),
        new Color(0, 70, 160),
    ]) {
        this.colorGradient = colorGradient;
    }
    colorByScore(score, minScore = 0.5) {
        if (score < 0 || score > 1) {
            throw new RangeError("score must be between 0 and 1, including 0 and 1.");
        }
        if (minScore < 0 || minScore > 1) {
            throw new RangeError("minScore must be between 0 and 1, including 0 and 1.");
        }
        if (minScore >= score) {
            return this.colorGradient[0];
        }
        const step = (1 - minScore) / this.colorGradient.length;
        const index = Math.floor((score - minScore) / step);
        return this.colorGradient[index];
    }
    maxScore(features) {
        let maxScore = 0;
        for (const feature of features) {
            const job = feature.get("job");
            const score = job.score / 100;
            maxScore = Math.max(maxScore, score);
        }
        return maxScore;
    }
    polygonStyle(score, size, weight) {
        let radius = 0;
        let offsety = 0;
        if (weight < 10)
            radius = 10;
        else if (weight < 100)
            radius = 15;
        else if (weight < 1000) {
            radius = 20;
            offsety = 0.5;
        }
        else if (weight < 10000) {
            radius = 23;
            offsety = 0.5;
        }
        return new Style({
            image: new CircleStyle({
                radius: radius,
                stroke: new Stroke({
                    color: "rgba(41, 120, 168, 1)",
                    width: 1.5,
                }),
                fill: new Fill({
                    color: "rgba(202, 222, 234, 1)",
                }),
            }),
            text: new Text({
                text: weight.toString(),
                font: "13px sans-serif",
                scale: 0.9,
                offsetY: offsety,
                placement: new TextPlacement({ textAlign: 'center' }),
                fill: new Fill({
                    color: "#2978A8",
                }),
            }),
        });
    }
    polygonStyle2(score, size, weight) {
        let radius = 0;
        let offsety = 0;
        if (weight < 10)
            radius = 10;
        else if (weight < 100)
            radius = 15;
        else if (weight < 1000) {
            radius = 20;
            offsety = 0.5;
        }
        else if (weight < 10000) {
            radius = 23;
            offsety = 0.5;
        }
        return new Style({
            image: new CircleStyle({
                radius: radius,
                stroke: new Stroke({
                    color: "rgba(41, 120, 168, 1)",
                    width: 1.5,
                }),
                fill: new Fill({
                    color: "rgba(202, 222, 234, 1)",
                }),
            }),
            text: new Text({
                text: weight.toString(),
                font: "13px sans-serif",
                scale: 0.9,
                offsetY: offsety,
                placement: new TextPlacement({ textAlign: 'center' }),
                fill: new Fill({
                    color: "#2978A8",
                }),
            }),
        });
    }
    clusterStyle(cluster) {
        const features = cluster.get("features");
        const weight = features[0].get("weight");
        const size = features.length;
        const score = this.maxScore(features);
        let style;
        if (features.length > 1) {
            let weight = 0;
            for (let i = 0; i < features.length; i++) {
                weight += features[i].get("weight");
            }
            style = this.polygonStyle(score, size, weight);
        }
        else {
            style = this.polygonStyle2(score, size, features[0].get("weight"));
        }
        return [style];
    }
}
